import { InjectionToken, Provider } from '@angular/core';

import { FirebaseOptions } from 'firebase/app';

export const FIREBASE_OPTIONS = new InjectionToken<FirebaseOptions>('Firebase Options');

export const provideFirebaseOptions = (options: FirebaseOptions): Provider => ({
  provide: FIREBASE_OPTIONS,
  useValue: options,
});
